import React, { useMemo } from 'react';

import { Chip, ChipStatus } from '@appcharge/shared-ui';

import { HttpStatusCategory } from '../integration-test-modal.types';

interface IResponseStatusBadgeProps {
  statusCode: number;
  statusText: string;
  className?: string;
}

const STATUS_CODE_THRESHOLD_SUCCESS = 200;
const STATUS_CODE_THRESHOLD_REDIRECT = 300;
const STATUS_CODE_THRESHOLD_CLIENT_ERROR = 400;

const CHIP_STATUS_BY_CATEGORY: Record<HttpStatusCategory, ChipStatus> = {
  [HttpStatusCategory.SUCCESS]: 'success',
  [HttpStatusCategory.ERROR]: 'danger',
  [HttpStatusCategory.PENDING]: 'warning'
};

const getStatusCategory = (statusCode: number): HttpStatusCategory => {
  if (statusCode >= STATUS_CODE_THRESHOLD_SUCCESS && statusCode < STATUS_CODE_THRESHOLD_REDIRECT) {
    return HttpStatusCategory.SUCCESS;
  }
  if (statusCode >= STATUS_CODE_THRESHOLD_CLIENT_ERROR) {
    return HttpStatusCategory.ERROR;
  }
  return HttpStatusCategory.PENDING;
};

export const ResponseStatusBadge: React.FC<IResponseStatusBadgeProps> = ({
  statusCode,
  statusText,
  className
}) => {
  const chipStatus = useMemo(
    () => CHIP_STATUS_BY_CATEGORY[getStatusCategory(statusCode)],
    [statusCode]
  );

  return (
    <Chip variant="flat" status={chipStatus} className={className}>
      {statusCode} {statusText}
    </Chip>
  );
};

